import * as React from 'react';
import s from './Notification.scss';
import { withInjectedRootStore, RootStore } from '../../providers';
import { observer } from 'mobx-react';
import { Notification as WixNotification } from 'wix-style-react';

export interface NotificationCompProps {
  rootStore: RootStore;
}

export interface NotificationProps {
  message?: string;
  isDisplayed: boolean;
  actionText?: string;
  onActionButtonClick?(): void;
  linkUrl?: string;
}

@observer
export class NotificationComp extends React.Component<NotificationCompProps> {
  render() {
    const { rootStore } = this.props;
    const {
      isDisplayed,
      message,
      linkUrl,
      onActionButtonClick,
      actionText,
    } = rootStore.notificationStore.notification;

    return (
      <div className={s.root} data-hook='notification'>
        <WixNotification
          show={isDisplayed}
          theme='error'
          type='global'
          dataHook='app-notification'
        >
          <WixNotification.TextLabel>{message}</WixNotification.TextLabel>
          {!linkUrl && (
            <WixNotification.ActionButton
              onClick={onActionButtonClick}
              type='button'
            >
              {actionText}
            </WixNotification.ActionButton>
          )}
          <WixNotification.CloseButton />
        </WixNotification>
      </div>
    );
  }
}
export const Notification = withInjectedRootStore(NotificationComp);
